import React from 'react'

import { Handler } from '../../helpers/typeHelper'
import { FlexBox } from '../Base/FlexBox'
import { TabLink } from '../TabLink/TabLink'

interface SubNavProps {
  items: SubNavItem[]
}

export interface SubNavItem {
  label: React.ReactNode
  isActive?: boolean
  onClick: Handler
}

export function SubNav({ items }: SubNavProps) {
  return (
    <FlexBox gap="32px">
      {items.map((item, index) => (
        <TabLink key={index} onClick={item.onClick} $isSelected={item.isActive} $small>
          {item.label}
        </TabLink>
      ))}
    </FlexBox>
  )
}
